import type { TagType } from "@/components/Tag/Tag";
import { toDateTimeFormat } from "@/lib/dateHelpers";
import type { BackgroundCheckOrder, BackgroundCheckOrderUpdate } from "./types";

export function formatOrderDateTime(value: string | null | undefined): string {
  if (!value) return "--";
  return toDateTimeFormat(value) ?? "--";
}

export function getOrderStatusTagType(status: string | null | undefined): TagType {
  switch (status) {
    case "Completed":
      return "success";
    case "Pending":
    case "In-Progress":
    case "Pending Applicant":
    case "Pending Requestor":
      return "information";
    case "Invite Expired":
      return "warn";
    case "Sent":
      return "surface";
    default:
      return "surface";
  }
}

export function isPendingOrderResult(result: string | null | undefined): boolean {
  const normalized = result?.trim().toLowerCase();
  return !normalized || normalized === "pending";
}

export function getScreeningResultLabel(updates: BackgroundCheckOrderUpdate[]): string {
  return getLatestMeaningfulOrderResult(updates) ?? "Pending";
}

export function getOrderLastActivity(order: BackgroundCheckOrder): string | null {
  const latestUpdate = sortOrderUpdatesNewestFirst(order.updates ?? [])[0];
  return latestUpdate?.createdAt ?? order.updatedAt ?? order.createdAt ?? null;
}

export function getLatestMeaningfulOrderResult(updates: BackgroundCheckOrderUpdate[]): string | null {
  for (const update of sortOrderUpdatesNewestFirst(updates)) {
    if (!isPendingOrderResult(update.result)) {
      return update.result;
    }
  }

  return null;
}

export function sortOrderUpdatesNewestFirst(updates: BackgroundCheckOrderUpdate[]): BackgroundCheckOrderUpdate[] {
  return [...updates].sort((first, second) => Date.parse(second.createdAt) - Date.parse(first.createdAt));
}

export function formatOrderProgress(percentComplete: number | null | undefined): string {
  return percentComplete == null ? "--" : `${percentComplete}%`;
}
